/**
 * Created by viclight on 03.05.2024.
 */

import MainComponent from "components/Main";
import SelectMultiFilter from "../SelectMultiFilter";
import React from "react";
export default class EmployeesFilter extends MainComponent {

    constructor(props) {
        super(props);

        this.state = {
            roleFilter: [4],
            specFilter: [],
            statusFilter: ["WORK"]
        };

        const { specsStomatList, specsMedGeneralList } = this._config;

        this.specList = [...specsStomatList, ...specsMedGeneralList];

    }

    getSpecLabel(specId) {

        let it = this.specList.find((_it) => _it.id === specId);

        if (it !== undefined) {
            return this.tr(it.title);
        }
        return "";
    }

    onRemoveFilter(item) {
        const { roleFilter, specFilter, statusFilter } = this.state;

        let index;

        switch (item.id) {
            case "roleId":
                index = roleFilter.findIndex(val => val === item.value);
                if (index !== -1) {
                    roleFilter.splice(index, 1);
                    this.setState({ roleFilter });
                }
                break;
            case "specId":
                index = specFilter.findIndex(val => val === item.value);
                if (index !== -1) {
                    specFilter.splice(index, 1);
                    this.setState({ specFilter });
                }
                break;

            case "status":
                index = statusFilter.findIndex(val => val === item.value);
                if (index !== -1) {
                    statusFilter.splice(index, 1);
                    this.setState({ statusFilter });
                }
                break;

            default:
                break;

        }

        this.sendData();
    }

    setFired(value) {
        const { statusFilter } = this.state;
        let index = statusFilter.indexOf("FIRED");

        if (value) {
            if (index === -1) {
                statusFilter.push("FIRED");
            }
        } else if (index >= 0) {
            statusFilter.splice(index, 1);
        }

        this.setState({ statusFilter });
        this.sendData();
    }

    changeFilter(key, value) {

        this.setState({ key: value });

        this.sendData();
    }

    sendData() {

        let filters = [];

        const { roleFilter, specFilter, statusFilter } = this.state;


        let labelType = this.tr("employee.role_system");

        for (let val of roleFilter) {
            filters.push({
                id: "roleId",
                value: val,
                labelValue: this._helper.getRoleLabel(val),
                labelType
            });
        }

        labelType = this.tr("employee.specialization");

        for (let val of specFilter) {
            filters.push({
                id: "specId",
                value: val,
                labelValue: this.getSpecLabel(val),
                labelType
            });
        }

        labelType = this.tr("employee.status");

        for (let val of statusFilter) {
            filters.push({
                id: "status",
                value: val,
                labelValue: this._helper.getEmploeeStatusLabel(val),
                labelType
            });
        }

        this.props.onChangeFilter(filters);


    }
    render() {

        const { employeeStatuses, rolesList } = this._config;
        const { roleFilter, specFilter, statusFilter } = this.state;


        return (
            <>
                <SelectMultiFilter
                    selected={roleFilter}
                    items={rolesList}
                    fixedHolder={this.tr("employee.role_system")}
                    onChange={this.changeFilter.bind(this, "roleFilter")}
                />

                <SelectMultiFilter
                    selected={specFilter}
                    items={this.specList}
                    labelKey={"title"}
                    fixedHolder={this.tr("employee.specialization")}
                    onChange={this.changeFilter.bind(this, "specFilter")}
                />

                <SelectMultiFilter
                    selected={statusFilter}
                    items={employeeStatuses}
                    fixedHolder={this.tr("employee.status")}
                    onChange={this.changeFilter.bind(this, "statusFilter")}
                />
            </>
        );

    }


}
